export const EVENTS_STORAGE = [] // If Google Analytics is not yet loaded, we store events in this list and send them after loading GA

export function logGoogleAnalyticsEvent (eventAction, eventCategory = 'general', eventLabel = null, callback = null) {
  if (window.gtag) {
    let calledCallback = false
    if (callback) {
      // Set a timer that will execute the callback function, in case that logging to google analytics fails
      setTimeout(() => {
        if (!calledCallback) {
          calledCallback = true
          callback()
        }
      }, 1000)
    }
    window.gtag('event', eventAction, {
      event_category: eventCategory,
      event_label: eventLabel,
      event_callback: () => {
        if (callback && !calledCallback) {
          calledCallback = true
          callback()
        }
      },
    })
  } else {
    // The javascript tag for Google Analytics has not yet been loaded. Store the event so it can be sent later
    EVENTS_STORAGE.push({ eventAction, eventCategory, eventLabel })
    if (callback) {
      callback()
    }
  }
}
